import script from "./stmn-agncy-cnsg-rqt.vue?vue&type=script&setup=true&lang=js"
export * from "./stmn-agncy-cnsg-rqt.vue?vue&type=script&setup=true&lang=js"

import "./stmn-agncy-cnsg-rqt.vue?vue&type=style&index=0&id=7121f1b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7121f1b6"]])

export default __exports__